// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"937":"d3e4e1ea","981":"a592c411"}[chunkId] + ".chunk.js";
};